import React, { useMemo } from 'react';
import {
  useWindowSize,
} from 'vindi-ds-components';
import useToggle from '@hooks/feature_toggles';
import Header from './components/header';
import Table from './components/table';
import TableCard from './components/tableCard';

function Products() {
  const toggle = useToggle('new_product_page');
  const { isMobile } = useWindowSize();

  const List = useMemo(
    () => (isMobile ? TableCard : Table),
    [isMobile],
  );

  if (!toggle) {
    return null;
  }

  return (
    <>
      <Header />
      <List />
    </>
  );
}

export default Products;
